import dayjs from "dayjs";

export const ALL = "All";
export const UPCOMING = "Upcoming";
export const COMPLETED = "Completed";
export const OVERDUE = "Overdue";

export const DUE_DATE_FILTERS = [
  { text: "Today", value: "TODAY" },
  { text: "Tomorrow", value: "TOMORROW" },
  { text: "Next 7 days", value: "NEXT_7_DAYS" },
  { text: "Yesterday", value: "YESTERDAY" },
  { text: "Last 7 Days", value: "LAST_7_DAYS" },
];

// Server field names for sorting
export const SERVER_SORT_FIELDS = {
  TASK_NAME: "task_name",
  DUE_DATE: "due_date",
  CREATION_DATE: "creation_date",
  COMPLETION_DATE: "completion_date",
  ASSIGNED_TO: "assigned_to",
  CREATED_BY: "created_by",
};

// Field mapping for client to server fields
export const FIELD_MAPPING = {
  title: SERVER_SORT_FIELDS.TASK_NAME,
  dueDate: SERVER_SORT_FIELDS.DUE_DATE,
  createTs: SERVER_SORT_FIELDS.CREATION_DATE,
  completionDate: SERVER_SORT_FIELDS.COMPLETION_DATE,
  assignedTo: SERVER_SORT_FIELDS.ASSIGNED_TO, // Changed from "assignedTo.fullName"
  createdBy: SERVER_SORT_FIELDS.CREATED_BY, // Changed from "createdBy.fullName"
};

// Task status constants
export const TASK_STATUS = {
  CREATED: "CREATED",
  COMPLETED: "COMPLETED",
  OVERDUE: "OVERDUE",
  UPCOMING: "UPCOMING",
};

export const TASK_STATUS_TAGS = {
  [TASK_STATUS.CREATED]: {
    color: "blue",
  },
  [TASK_STATUS.COMPLETED]: {
    color: "green",
  },
  [TASK_STATUS.OVERDUE]: {
    color: "red",
  },
  [TASK_STATUS.UPCOMING]: {
    color: "orange",
  },
};

export const formatDueDateTime = (dateInput, timeInput) => {
  const date = dayjs(dateInput).format("YYYY-MM-DD");
  const time = dayjs(timeInput).format("HH:mm:ss.SSS");
  return dayjs(`${date}T${time}Z`).toISOString();
};
